import React from "react";
import ActionButton from "../utils/ActionButton";
import Footer from "../components/Footer";
import LandingSection from "../components/LandingSection";
import "../styles/UtahMap.css";

const map = "/img/utah-map.png";

const UtahState = () => {
  const totalPopulation = "3,454,000";
  const totalArea = "84,899 sq mi";
  return (
    <>
      <div>
        <LandingSection
          data={{ imageName: "geoandinsights.webp", title: "Utah State" }}
        />
        <div className="verticals_section">
          <div className="verticals-intro">
            <div className="verticals-intro-sec1">
              <h2>
                Utah State: A Hub of Natural Beauty and Economic Growth Blending
                Innovation, Tradition, and Quality of Life
              </h2>
            </div>
            <div className="verticals-intro-sec2">
              <p>
                Utah, located in the western United States, is known for its
                stunning natural landscapes, strong economy, and vibrant
                communities. The state is home to a diverse geography that
                includes the Rocky Mountains, the Great Salt Lake, and five
                nationally renowned national parks—Arches, Zion, Bryce Canyon,
                Capitol Reef, and Canyonlands
              </p>
              <ActionButton data="Explore More" link="/contact-us"/>
            </div>
          </div>
        </div>
        <div className="utah-map-container">
          <img src={map} alt="Utah Map" className="utah-map-image" />
          <div className="population-overlay">
            <h2> Utah Population:</h2>
            <p>{totalPopulation}</p>
            <h2> Area in Utah:</h2>
            <p>{totalArea}</p>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default UtahState;
